import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";
import { Button } from "@circleco/compass/components/Button";
import type { MouseEvent } from "react";

export interface CompassLikeImageInputOverlayProps {
  changeButtonText?: string;
  onChange?: (event: MouseEvent<HTMLButtonElement>) => void;
  onDelete?: (event: MouseEvent<HTMLButtonElement>) => void;
  removeButtonText?: string;
}

export const CompassLikeImageInputOverlay = ({
  changeButtonText,
  onChange,
  onDelete,
  removeButtonText,
}: CompassLikeImageInputOverlayProps) => {
  const { isViewOnlyMasquerading } = usePunditUserContext();

  return (
    <div
      className="absolute top-0 flex size-full items-center justify-center gap-2 rounded-md bg-inverse/20 opacity-0 transition-opacity duration-300 hover:opacity-100 focus-within:opacity-100"
      data-testid="image-input-overlay"
    >
      <Button
        variant="secondary"
        size="sm"
        startIcon="arrow-box-up"
        type="button"
        onClick={onChange}
        disabled={isViewOnlyMasquerading}
      >
        {changeButtonText}
      </Button>
      <Button
        variant="destructive"
        size="sm"
        startIcon="cross"
        onClick={onDelete}
        type="button"
        disabled={isViewOnlyMasquerading}
      >
        {removeButtonText}
      </Button>
    </div>
  );
};
